import React from 'react';
import ReactDom from 'react-dom';
import { App } from './App';
if (typeof window.ethereum !== 'undefined') {
    window.ethereum.autoRefreshOnNetworkChange = false;
}
ReactDom.render(React.createElement(App, null), document.getElementById('app'));
